import React, { Component } from "react";

import Dialog from "./DraggableModal";
import "./stylesDraggable.scss";
//import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
// MdContentCopy
//VscCopy
//MdOutlineContentCopy
import { MdOutlineContentCopy } from "react-icons/md";

export default class MainApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showDialog: false,
    };
  }

  _showDialog() {
    this.setState({ showDialog: !this.state.showDialog });
  }

  render() {
    return (
      <div className="wrapper-btn-showDialog">
        <div className="button-dragMain" onClick={this._showDialog.bind(this)}>
          {/* Show Dialog */}
          <MdOutlineContentCopy
            style={{
              width: `calc(18px + 2vmin)`,
              height: `calc(18px + 2vmin)`,
            }}
          />
        </div>
        <Dialog
          onClose={this._showDialog.bind(this)}
          show={this.state.showDialog}
        />
      </div>
    );
  }
}
